/* Favicons entry point for webpack
 * html_code.html as expected output from realfavicongenerator.net
 * manually insert `WEBPACKHACK` to content attribute of meta[name="msapplication-config"] i.e.
 * <meta name="msapplication-config" WEBPACKHACKcontent="./browserconfig.xml">
 */

import './sprites';
import './components';
import './utilities';
require('./favicons/html_code.html');



// WEBPACK FOOTER //
// ./client/src/site__evo/index.js